// extracted by mini-css-extract-plugin
export var shouldntWrap = "source_code-module--shouldntWrap--4nA7J";
export var sourceCode = "source_code-module--sourceCode--XrIWT";